// extracted by mini-css-extract-plugin
export default {"header__icons":"SocialIcon_header__icons__qVw25","header__icon":"SocialIcon_header__icon__zylrN"};